module.exports = __webpack_public_path__ + "static/img/aboutpretrendr.dbde377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing-page/aboutpretrendr.jpg
// module id = 424
// module chunks = 1